import React, { useState, useRef, useEffect } from 'react';
import '../../assets/vendor/css/pages/page-auth.css'
import { Link, useNavigate } from 'react-router-dom';

import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { getToken, setUserSession, getUserType } from '../../helpers/Helper';
import { POST_LOGIN, POST_AUTO_LOGIN } from '../../helpers/url_helper';
import { toast } from 'react-toastify';

import Auth_Img from './../../assets/img/auth_img.png';
import Loader from '../../components/Loader';

import { useTranslation } from 'react-i18next';

import Logo from './../../assets/img/logo.svg';
const Login = (props) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const [isLoader, setLoader] = useState(0);

    useEffect(() => {
        const autoLogin = async (userId) => {

            var res_data = await post(POST_AUTO_LOGIN, { userId: userId });
            if (res_data.status) {
                setUserSession(res_data.data.token, res_data.data, true);
                navigate("/dashboard");
                setLoader(1);
            } else {
                navigate("/");
                toast.error(res_data.message);
            }
        }

        const queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('id')) {
            autoLogin(queryParams.get('id'));
        } else {
            setLoader(1)
        }

        if (getToken() && getUserType() === 'User') {
            navigate("/dashboard");
        } else if (getToken() && getUserType() !== 'User') {
            navigate("/admin/dashboard");
        }

        setLoader(1);
    }, [navigate])


    const simpleValidator = useRef(new SimpleReactValidator());

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [login_inputs, setInputs] = useState({ email: '', password: '', otp: '', otp_screen: false });
    const [, forceUpdate] = useState();

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_LOGIN, login_inputs, {});
            if (res_data.status) {
                setUserSession(res_data.data.token, res_data.data);
                if (res_data.data.type === 'User') {
                    navigate("/dashboard");
                } else {
                    navigate("/admin/dashboard");
                }
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...login_inputs, [event.target.name]: event.target.value }));
    }


    return (
        <>
            {(!isLoader) && <Loader />}
            <div className="authentication-wrapper authentication-cover">
                <div className="authentication-inner row m-0">
                    <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
                        <div className="w-100 d-flex justify-content-center">
                            <img src={Auth_Img} className="img-fluid" alt="Login" width="700" />
                        </div>
                    </div>

                    <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
                        <div className="w-px-400 mx-auto">
                            <div className="app-brand mb-5">
                                <img src={Logo} alt='Cheque Print' style={{ "width": '300px' }} />
                            </div>
                            <h4 className="mb-2">{t('signIn.signInTitle')}</h4>
                            <p className="mb-4">{t('signIn.signInSubTitle')}</p>

                            <form className="mb-3" onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label>{t('signIn.form.emailAddress')}</label>
                                    <input name="email" value={login_inputs.email} onChange={handleInputChange} className="form-control" placeholder={t('signIn.Placeholder.emailAddress')} type="text" />
                                    {simpleValidator.current.message('email', login_inputs.email, 'required|email', { messages: { "required": t('signIn.formError.emailAddressRequired'), email: t('signIn.formError.emailAddressValid') } })}
                                </div>
                                <div className="mb-3 form-password-toggle">
                                    <div className="d-flex justify-content-between">
                                        <label for="password">{t('signIn.form.password')}</label>
                                        <Link to="/forgot" className='text-primary'>
                                            <small>{t('signIn.forgotPassword')}</small>
                                        </Link>
                                    </div>
                                    <div className="input-group input-group-merge">
                                        <input name="password" value={login_inputs.password} onChange={handleInputChange} type="password" className="form-control" placeholder={t('signIn.Placeholder.password')} />
                                    </div>
                                    {simpleValidator.current.message('password', login_inputs.password, 'required', { messages: { required: t('signIn.formError.passwordRequired') } })}
                                </div>

                                <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2 w-100">
                                    {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('signIn.signIn')}
                                </button>
                                <div className='mt-3'>
                                    <p className="text-center">
                                        <span>{t('signIn.newOnOurPlatform')}</span>
                                        <Link to="/signup" className='text-primary'>
                                            <span> {t('signIn.createAnAccount')}</span>
                                        </Link>
                                    </p>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Login;